import { createDotGlobePattern } from "./internal/dotGlobeCore";

export const key = "dot-globe";

// Centered globe at the auto-sized radius — the original variant.
export default createDotGlobePattern({
  placement: ({ width, height, autoRadius }) => ({
    cx: width / 2,
    cy: height / 2,
    radius: autoRadius,
  }),
});
